<template>
  <div>
    <v-container class="content-wrapper" id="edit-campaign">
      <v-row>
        <v-col cols="12" sm="4" md="2">
          <h2 class="black--text font-weight-bold">
            {{ $t('edit') }}
          </h2>
        </v-col>
        <v-col cols="12" sm="8" md="9" class="d-flex justify-end flex-wrap">
          <v-btn outlined class="custom-button" rounded large @click="cancel">
            <v-icon class="mr-2">mdi-close-box-outline</v-icon>
            {{ $t('cancel') }}
          </v-btn>
          <v-btn outlined class="custom-button" rounded large @click="togglePreview">
            <v-icon class="mr-2">mdi-eye-outline</v-icon>
            {{ $t('preview') }}
          </v-btn>
          <v-btn outlined class="custom-button" rounded large @click="saveAsDraft">
            <v-icon class="mr-2">mdi-note-text-outline</v-icon>
            {{ $t('save-as-draft') }}
          </v-btn>
          <v-btn
            outlined
            class="custom-button"
            rounded
            large
            @click="publish"
            v-if="campaignStatus === 'PUBLISHED'"
          >
            <v-icon class="mr-2">mdi-upload</v-icon>
            {{ $t('publish') }}
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <v-divider class="my-5" style="width: 1640px;"></v-divider>

      <v-row>
        <v-col xl="auto" lg="3" md="4" sm="4" xs="12">
          <v-card elevation="3" style="border-radius: 24px;">
            <v-card-text>
              <v-col>
                <v-menu
                  v-model="dateFromMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="dateFrom"
                      label="Date From"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      class="required"
                      :rules="requiredRule()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateFrom"
                    @input="dateFromMenu = false"
                    color="rgba(157, 87, 244, 1)"
                    :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-card-text>
            <v-card-text>
              <v-col>
                <v-menu
                  v-model="dateToMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      v-model="dateTo"
                      label="Date To"
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      class="required"
                      :rules="requiredRule()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateTo"
                    @input="dateToMenu = false"
                    color="rgba(157, 87, 244, 1)"
                    :first-day-of-week="1"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-card-text>

            <v-divider class="mx-5"></v-divider>

            <v-card-text>
              <v-checkbox v-model="applicationForm" class="ml-5" color="rgba(157, 87, 244, 1)">
                <template v-slot:prepend>
                  <span class="black--text font-weight-bold ">Apply</span>
                </template>
              </v-checkbox>
            </v-card-text>
            <v-card-text class="pt-0" v-if="applicationForm">
              <v-checkbox
                v-model="questionDialog"
                @change="openDialog"
                class="ml-5 mt-0"
                color="rgba(157, 87, 244, 1)"
              >
                <template v-slot:prepend>
                  <span class="black--text font-weight-bold ">Create your Question</span>
                </template>
              </v-checkbox>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="9" lg="9" sm="8" xs="12">
          <v-card elevation="3" style="border-radius: 24px;">
            <v-card-text class="mt-4">
              <v-text-field
                label="Headline"
                v-model="headline"
                outlined
                class="required"
                :rules="requiredRule()"
              ></v-text-field>
            </v-card-text>
            <v-divider class="mx-5"></v-divider>
            <v-card-text class="mt-4">
              <v-text-field
                label="Title"
                v-model="title"
                outlined
                class="required"
                :rules="requiredRule()"
              ></v-text-field>
            </v-card-text>
            <v-card-text>
              <tiptap-vuetify
                v-model="description"
                :placeholder="'Description*'"
                :extensions="extensions"
              ></tiptap-vuetify>
            </v-card-text>
            <v-card-title>
              <div class="black--text font-weight-bold">
                Tags
              </div>
            </v-card-title>
            <v-card-text>
              <div class="grey--text font-weight-bold">
                Enter your tags (keywords) by pressing enter.
              </div>
            </v-card-text>
            <v-card-text>
              <v-text-field
                v-model="newTag"
                label="Type Tag Names"
                outlined
                @keyup.enter="addTag"
              ></v-text-field>
              <v-chip-group column>
                <v-chip
                  v-for="(tag, index) in tags"
                  :key="index"
                  close
                  @click:close="removeTag(index)"
                >
                  {{ tag }}
                </v-chip>
              </v-chip-group>
            </v-card-text>
            <v-card-text>
              <v-file-input label="Attach Files" outlined v-model="addFile"></v-file-input>
            </v-card-text>
            <v-card-text v-if="files.length">
              <v-chip
                v-for="(file, index) in files"
                :key="index"
                close
                @click:close="removeFile(index)"
                class="ma-1"
              >
                {{ file }}
              </v-chip>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-row style="width: 100%;" justify="center">
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    rounded
                    large
                    class="custom-button"
                    outlined
                    @click="uploadFile"
                    >Upload File
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Edit Question Dialog -->
      <v-dialog v-model="dialogVisible" max-width="675px" persistent>
        <v-card
          class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
        >
          <v-card-title>
            Write your Multiple Choice Question
          </v-card-title>
          <v-card-text class="mt-4">
            <v-text-field placeholder="Question" v-model="question" outlined></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field
              v-model="newAnswer"
              placeholder="Write an Answer and Press Enter"
              outlined
              @keyup.enter="addAnswer"
            ></v-text-field>
            <v-chip-group column>
              <v-chip
                v-for="(answer, index) in answers"
                :key="index"
                close
                @click:close="removeAnswer(index)"
              >
                {{ answer }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
          <v-card-text class="mt-0 pt-0">
            <v-btn
              block
              depressed
              rounded
              large
              class="custom-button"
              outlined
              @click="deleteFirstQuestion"
              >Delete Multiple Choice Question & Answers
            </v-btn>
          </v-card-text>
          <v-card-text class="mt-0 pt-0">
            <v-btn
              block
              depressed
              rounded
              large
              class="custom-button"
              outlined
              @click="addSecondQuestionModal"
              >Edit or Add Free Text Question
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-row style="width: 100%">
              <v-col cols="6">
                <v-btn
                  block
                  depressed
                  rounded
                  large
                  class="custom-button"
                  outlined
                  @click="closeQuestionDialog"
                  >{{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block depressed rounded large class="custom-button" @click="confirmQuestion"
                  >{{ $t('confirm') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Second Question Dialog -->
      <v-dialog v-model="secondQuestionDialog" max-width="675px">
        <v-card
          class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
        >
          <v-card-title>
            Free Text Question Form
          </v-card-title>
          <v-card-text class="mt-4">
            <v-text-field
              placeholder="Write your Free Text Question"
              v-model="secondQuestion"
              outlined
            ></v-text-field>
            <v-card-text class="mt-0 pt-0">
              <v-btn
                block
                depressed
                rounded
                large
                class="custom-button"
                outlined
                @click="deleteSecondQuestion"
                >Delete Question
              </v-btn>
            </v-card-text>
            <v-card-actions>
              <v-row style="width: 100%">
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    rounded
                    large
                    class="custom-button"
                    outlined
                    @click="closeSecondQuestionDialog"
                    >{{ $t('cancel') }}
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    rounded
                    large
                    class="custom-button"
                    @click="confirmSecondQuestion"
                    >{{ $t('confirm') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Status Dialog -->
      <v-dialog v-model="statusDialog" max-width="675px">
        <v-card
          class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
        >
          <v-card-title> Campaign {{ campaignId }} </v-card-title>
          <v-card-text>
            <p>
              There is a campaign with ID
              <span style="color: rgba(157, 87, 244, 1); font-weight: bold;">
                {{ campaignId }} </span
              ><br />Do you want to unpublish it first?
            </p>
          </v-card-text>
          <v-card-actions>
            <v-row width="100%">
              <v-col cols="6">
                <v-btn
                  block
                  depressed
                  rounded
                  large
                  class="custom-button"
                  outlined
                  @click="statusDialog = false"
                  >{{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  block
                  depressed
                  rounded
                  large
                  class="custom-button"
                  outlined
                  @click="unpublish(campaignId)"
                  >{{ $t('Unpublish') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Preview Edit Campaign Dialog -->
      <v-dialog v-model="previewDialog">
        <v-card
          class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
        >
          <v-card-text>
            <v-container>
              <v-row class="mb-13 pb-13">
                <v-col
                  cols="12"
                  lg="4"
                  :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : 'text-left'"
                >
                  <h2 class="primary300--text mb-2">
                    {{ dialogTitle }}
                  </h2>
                  <div v-html="dialogDescription"></div>
                  <div>
                    <v-card-text v-if="files.length">
                      <v-chip
                        v-for="(file, index) in files"
                        :key="index"
                        color="primary200"
                        text-color="white"
                        close
                        @click:close="removeFile(index)"
                        class="ma-1"
                      >
                        {{ file }}
                      </v-chip>
                    </v-card-text>
                  </div>
                  <v-btn
                    v-if="applicationForm"
                    color="primary200"
                    dark
                    class="mt-10  pl-16 pr-16 pt-9 pb-9 white--text "
                    :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : 'text-left'"
                    x-large
                    :style="{
                      width: $vuetify.breakpoint.mdAndDown ? '100%' : '480px',
                    }"
                    @click="applicationFormDialog = true"
                  >
                    Apply Now
                  </v-btn>
                  <ApplicationFormForPreview
                    :dialog="applicationFormDialog"
                    :firstQuestion="question"
                    :firstAnswer="answers"
                    :secondQuestion="secondQuestion"
                    @close="applicationFormDialog = false"
                  ></ApplicationFormForPreview>
                </v-col>
                <v-spacer></v-spacer>
                <v-col
                  cols="12"
                  lg="6"
                  class="text-right "
                  :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : 'text-right'"
                >
                  <div class="image-wrapper">
                    <v-img src="../../../assets/img/landing-page/pages/new_about.jpg"></v-img>
                    <div class="overlay"></div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { Bold, Underline, Italic, Strike, TiptapVuetify } from 'tiptap-vuetify';
import EventBus from '@/helpers/event-bus.js';
import ApplicationFormForPreview from './ApplicationFormForPreview.vue';

import util from '@/mixins/util';

export default {
  mixins: [util],
  components: { TiptapVuetify, ApplicationFormForPreview },
  data: () => ({
    dateFrom: null,
    dateTo: null,
    dateFromMenu: false,
    dateToMenu: false,
    applicationForm: false,
    applicationFormDialog: false,
    questionDialog: false,
    dialogVisible: false,
    campaignIdQuestion: null,
    campaignIdSecondQuestion: null,
    campaignId: null,
    statusDialog: false,
    question: '',
    secondQuestionDialog: false,
    secondQuestion: '',
    headline: '',
    title: '',
    description: '',
    tags: [],
    newTag: '',
    newAnswer: '',
    answers: [],
    questions: [],
    previewDialog: false,
    dialogTitle: '',
    dialogDescription: '',
    addFile: null,
    files: [],
    extensions: [Bold, Underline, Italic, Strike],
  }),
  created() {
    const id = this.$route.params.id;

    this.getDataFromApi(id);
  },
  computed: {
    campaignStatus() {
      const currentDate = new Date();
      const fromDate = new Date(this.dateFrom);
      fromDate.setHours(0, 0, 0, 0);
      const toDate = new Date(this.dateTo);
      toDate.setHours(23, 59, 59, 999);
      return currentDate >= fromDate && currentDate <= toDate ? 'PUBLISHED' : 'DRAFT';
    },
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    removeFile(index) {
      const id = this.$route.params.id;
      const fileToRemove = this.files[index];

      if (fileToRemove) {
        this.files.splice(index, 1);

        console.log('File to remove:', fileToRemove);

        this.axios
          .put(`api/v1/campaign/${id}/file?filename=${encodeURIComponent(fileToRemove)}`)
          .then(response => {
            console.log('Response Add File:', response.data);
            EventBus.$emit('snackbar', {
              text: 'File deleted successfully!',
            });
            this.getDataFromApi(id);
          })
          .catch(error => {
            console.log('Error:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to delete file. Please try again.',
            });
          });
      } else {
        console.log('Invalid file or id');
      }
    },
    saveAsDraft() {
      if (
        !this.description ||
        this.description.trim() === '<p></p>' ||
        this.description.trim() === '<strong></strong>' ||
        this.description.trim() === '<em></em>' ||
        this.description.trim() === '<s></s>'
      ) {
        EventBus.$emit('snackbar', {
          text: 'Description is required to save as draft the campaign.',
        });
        return;
      }

      EventBus.$emit('waiting', true);

      const campaignQuestions = [];

      if (this.question) {
        campaignQuestions.push({
          question: this.question,
          campaignAnswers: this.answers,
          id: this.campaignIdQuestion,
          hasAnswers: true,
        });
      }

      if (this.secondQuestion) {
        campaignQuestions.push({
          question: this.secondQuestion,
          id: this.campaignIdSecondQuestion,
          hasAnswers: false,
        });
      }

      this.deleteEmptyProperties(campaignQuestions);

      const payload = {
        id: this.$route.params.id,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        applicationForm: this.applicationForm,
        headline: this.headline,
        title: this.title,
        description: this.description,
        tags: this.tags,
        status: 'DRAFT',
        campaignQuestions,
      };

      this.deleteEmptyProperties(payload);

      this.axios
        .post('/api/v1/campaign', payload)
        .then(response => {
          console.log('Response:', response.data);
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('Saved as Draft'),
            color: 'primary200',
          });
          this.$router.push({ name: 'Campaign' });
        })
        .catch(error => {
          console.log('Error:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    getCampaignData() {
      return this.axios
        .get('api/v1/campaign?size=1000')
        .then(response => {
          if (response.status === 200) {
            const items = response.data.content || [];

            const publishedCampaigns = items
              .filter(item => item.status === 'PUBLISHED')
              .map(item => ({
                status: item.status,
                id: item.id,
              }));

            this.campaignId = publishedCampaigns.length > 0 ? publishedCampaigns[0].id : null;
            return this.campaignId;
          }
          return null;
        })
        .catch(error => {
          console.error('Error fetching campaign data:', error);
          return null;
        });
    },
    publish() {
      if (
        !this.description ||
        this.description.trim() === '<p></p>' ||
        this.description.trim() === '<strong></strong>' ||
        this.description.trim() === '<em></em>' ||
        this.description.trim() === '<s></s>'
      ) {
        EventBus.$emit('snackbar', {
          text: 'Description is required to publish the campaign.',
        });
        return;
      }

      EventBus.$emit('waiting', true);

      const campaignQuestions = [];

      if (this.question) {
        campaignQuestions.push({
          question: this.question,
          campaignAnswers: this.answers,
          id: this.campaignIdQuestion,
          hasAnswers: true,
        });
      }

      if (this.secondQuestion) {
        campaignQuestions.push({
          question: this.secondQuestion,
          id: this.campaignIdSecondQuestion,
          hasAnswers: false,
        });
      }

      this.deleteEmptyProperties(campaignQuestions);

      const payload = {
        id: this.$route.params.id,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        applicationForm: this.applicationForm,
        headline: this.headline,
        title: this.title,
        description: this.description,
        tags: this.tags,
        status: this.campaignStatus,
        campaignQuestions,
      };

      this.deleteEmptyProperties(payload);

      this.getCampaignData()
        .then(campaignId => {
          if (!campaignId) {
            return this.axios.post('/api/v1/campaign', payload);
          } else {
            this.statusDialog = true;
            throw new Error('Cannot publish: There is a campaign with status PUBLISHED.');
          }
        })
        .then(response => {
          console.log('Response:', response.data);
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('Publish Success'),
            color: 'primary200',
          });
          this.$router.push({ name: 'Campaign' });
        })
        .catch(error => {
          console.log('Error:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    unpublish() {
      EventBus.$emit('waiting', true);

      const payload = {
        status: 'DRAFT',
      };

      this.axios
        .put(`/api/v1/campaign/${this.campaignId}`, payload)
        .then(response => {
          console.log('Response:', response.data);
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('update-success'),
          });
          this.statusDialog = false;
        })
        .catch(error => {
          console.log('Error:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    uploadFile() {
      const id = this.$route.params.id;

      if (this.addFile && id) {
        console.log('full addfile', this.addFile);

        const formData = new FormData();
        formData.append('type', this.addFile.type);
        formData.append('name', this.addFile.name);
        formData.append('size', this.addFile.size);
        formData.append('file', this.addFile);

        this.axios
          .put(`api/v1/campaign/${id}/file`, formData)
          .then(response => {
            console.log('Response Add File:', response.data);
            EventBus.$emit('snackbar', {
              text: 'File uploaded successfully!',
            });
            this.getDataFromApi(id);
            this.addFile = null;
          })
          .catch(error => {
            console.log('Error:', error);
            EventBus.$emit('snackbar', {
              text: 'Failed to upload file. Please try again.',
            });
          });
      } else {
        console.log('Invalid file or id');
      }
    },
    confirmQuestion() {
      const campaignQuestion = {
        question: this.question,
        campaignAnswers: this.answers,
      };
      if (this.answers.length > 0 || this.secondQuestion) {
        this.dialogVisible = false;
        this.questionDialog = true;
      } else {
        this.dialogVisible = false;
        this.questionDialog = false;
      }

      console.log('Confirm Campaign Question', campaignQuestion);
    },
    confirmSecondQuestion() {
      const secondCampaignQuestion = {
        question: this.secondQuestion,
      };
      this.secondQuestionDialog = false;
      console.log('Confirm Second Campaign Question', secondCampaignQuestion);
    },
    cancel() {
      this.dateFrom = null;
      this.dateTo = null;
      this.applicationForm = false;
      this.headline = '';
      this.title = '';
      this.description = '';
      this.tags = [];

      // Redirect to the Campaign component
      this.$router.push({ name: 'Campaign' });
    },
    togglePreview() {
      this.previewDialog = true;
      this.dialogTitle = this.title ? this.title : 'Title';
      this.dialogDescription = this.description ? this.description : 'Description Text';
    },
    closeQuestionDialog() {
      this.secondQuestionDialog = false;

      if (this.answers.length > 0) {
        console.log('test', this.questions);
        this.dialogVisible = false;
        this.questionDialog = true;
      } else {
        this.dialogVisible = false;
        this.questionDialog = false;
      }
    },
    closeSecondQuestionDialog() {
      this.secondQuestionDialog = false;
    },
    addSecondQuestionModal() {
      this.secondQuestionDialog = true;
    },
    addTag() {
      const tag = this.newTag.trim();
      if (tag && !this.tags.includes(tag)) {
        this.tags.push(tag);
      }
      this.newTag = '';
    },
    addAnswer() {
      const answer = this.newAnswer.trim();
      if (answer && !this.answers.includes(answer)) {
        this.answers.push(answer);
      }
      this.newAnswer = '';
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    removeAnswer(index) {
      this.answers.splice(index, 1);
    },
    getDataFromApi(id) {
      console.log('Loading data');
      this.loading = true;
      EventBus.$emit('waiting', true);

      return new Promise((resolve, reject) => {
        this.axios
          .get(`api/v1/campaign/${id}`)
          .then(res => {
            console.log('API response:', res);
            if (res.status === 200) {
              const responseData = res.data;
              console.log('Extracted data:', responseData);

              this.title = responseData.title || '';
              this.headline = responseData.headline || '';
              this.description = responseData.description || '';
              this.dateFrom = responseData.dateFrom;
              this.dateTo = responseData.dateTo;
              this.tags = responseData.tags || [];
              this.applicationForm = responseData.applicationForm || false;
              this.files = responseData.files || [];

              this.questions = responseData.campaignQuestions || [];
              if (this.questions.length > 0) {
                this.questionDialog = true;
              }
              let hasAnswersQuestion = null;
              let noAnswersQuestion = null;

              this.questions.forEach(question => {
                if (question.hasAnswers) {
                  hasAnswersQuestion = question;
                } else {
                  noAnswersQuestion = question;
                }
              });

              this.question = hasAnswersQuestion ? hasAnswersQuestion.question : '';
              this.answers = hasAnswersQuestion ? hasAnswersQuestion.campaignAnswers : [];
              this.campaignIdQuestion = hasAnswersQuestion ? hasAnswersQuestion.id : null;
              this.secondQuestion = noAnswersQuestion ? noAnswersQuestion.question : '';
              this.campaignIdSecondQuestion = noAnswersQuestion ? noAnswersQuestion.id : null;

              resolve(responseData);
              EventBus.$emit('waiting', false);
            } else {
              reject(new Error(`API request failed with status: ${res.status}`));
            }
          })
          .catch(error => {
            console.error('Error fetching data:', error);
            EventBus.$emit('waiting', false);
            reject(error);
          });
      });
    },
    deleteFirstQuestion() {
      if (this.campaignIdQuestion) {
        const firstQuestionId = this.campaignIdQuestion;
        this.axios
          .delete(`/api/v1/campaign/campaign-question/${firstQuestionId}`)
          .then(response => {
            console.log('First question deleted successfully', response);
            const id = this.$route.params.id;
            this.getDataFromApi(id);
          })
          .catch(error => {
            console.error('Error deleting first question', error);
          });
      } else {
        this.question = '';
        this.answers = [];
      }
    },
    deleteSecondQuestion() {
      if (this.campaignIdSecondQuestion) {
        const secondQuestionId = this.campaignIdSecondQuestion;
        this.axios
          .delete(`/api/v1/campaign/campaign-question/${secondQuestionId}`)
          .then(response => {
            console.log('Second question deleted successfully', response);
            const id = this.$route.params.id;
            this.getDataFromApi(id);
          })
          .catch(error => {
            console.error('Error deleting second question', error);
          });
      } else {
        this.secondQuestion = '';
      }
    },
  },
};
</script>

<style scoped>
.custom-button {
  color: black;
  font-weight: bold;
  margin: 0 2px;
}

.custom-button:hover {
  background: rgba(157, 87, 244, 1);
  color: white;
  font-weight: bold;
}

.image-wrapper {
  position: relative;
  display: inline-block;
}

.image-wrapper .v-image {
  display: block;
  width: 700px;
  height: auto;
  border-radius: 24px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(100, 0, 255, 0.2);
  z-index: 0;
  pointer-events: none;
  border-radius: 24px;
}

@media (max-width: 768px) {
  .image-wrapper {
    max-width: 100%;
    overflow: hidden;
  }

  .image-wrapper .v-image {
    width: 100%;
    height: auto;
  }
}
</style>
